import { WrapperProps } from "@builder/components/wrappers/DynamicWrapper";
import { getAllLayerNodes, getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { useAppSelector } from "@builder/store/store";
import { BuildNode } from "@common/build/types";

import HookWrapper from "@common/components/HookWrapper";

const isDescendant = (components: { [key: string]: BuildNode }, currentNodeId: string, targetNodeId: string): boolean => {
    const currentNode = components[currentNodeId];

    if (currentNode.name === "repeaterDiv") return false;

    if (currentNode.parent) {
        if (currentNode.parent === targetNodeId) return true;
        return isDescendant(components, currentNode.parent, targetNodeId);
    }

    return false;
};

//to do: refactor to work with the filterChildren feature
const EmptyWrapper = (props: WrapperProps) => {
    const selectedNode = useAppSelector(getSelectedNode);
    const allLayerNodes = useAppSelector(getAllLayerNodes);

    if (selectedNode && props.node.id) {
        return <HookWrapper {...props} emptyState={isDescendant(allLayerNodes, selectedNode.id, props.node.id)} />;
    } else {
        return <HookWrapper {...props} emptyState={false} />;
    }
};

export default EmptyWrapper;
